import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { EUserType } from "../enums/EUserType";
import { UtilsService } from "./utils.service";

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    allPaths = {
        admin: {
            '/dashboard': true,
            '/customers': true,
            '/customers-view': true,
            '/users': true,
        },
        manager: {
            '/dashboard': true,
            '/customers': true,
            '/customers-view': true,
            // '/users': true,
        },
        operator: {
            '/dashboard': true,
            '/customers': true,
            // '/customers-view': true,
            // '/users': true,
        },
        user: {
            '/dashboard': true,
            // '/customers': true,
            '/customers-view': true,
        }
    }

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let user = this.authService.gUser;
        if (user && user._id) {
            if (user.usr_type_str === EUserType.ROOT) {
                return true;
            } else if (user.usr_type_str === EUserType.ADMIN) {
                if (this.allPaths.admin[state.url]) return true;
                else {
                    this.router.navigate(['admin-dashboard']);
                    return false;
                }
            } else if (user.usr_type_str === EUserType.MANAGER) {
                if (this.allPaths.manager[state.url]) return true;
                else {
                    this.router.navigate(['admin-dashboard']);
                    return false;
                }
            } else if (user.usr_type_str === EUserType.OPERATOR) {
                if (this.allPaths.operator[state.url]) return true;
                else {
                    this.router.navigate(['admin-dashboard']);
                    return false;
                }
            } else if (user.usr_type_str === EUserType.USER) {
                if (this.allPaths.user[state.url]) return true;
                else {
                    this.router.navigate(['admin-dashboard']);
                    return false;
                }
            } else {
                this.router.navigate(['login']);
                return false;
            }
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }

}
